export default "__VITE_ASSET__Cwc3MVHu__"